/**
 * liveRegion — tiny helper that writes into the app-wide sr-only live
 * region mounted once by AppShell (`#prairie-live-region`).
 *
 * Why not aria-live on the transient component itself? Most screen
 * readers only announce MUTATIONS to a live region that already existed
 * in the accessibility tree at the time of the update. Mounting the
 * region together with its content (as MilestoneMoment did before) means
 * the update is silently swallowed. Keeping one permanent, empty region
 * and writing text into it sidesteps that entire class of bug.
 *
 * Usage:
 *   import { announce } from "@/lib/liveRegion";
 *   announce("Milestone unlocked: First native identified.");
 */
export function announce(message) {
  if (typeof document === "undefined" || !message) return;
  const el = document.getElementById("prairie-live-region");
  if (!el) return;
  // Clear first so identical consecutive messages still trigger an
  // "aria-live change" event on the screen reader.
  el.textContent = "";
  // requestAnimationFrame gives the SR one paint tick to notice the
  // empty state before the new text is written — otherwise the two
  // mutations may coalesce into a single no-op.
  requestAnimationFrame(() => {
    el.textContent = String(message);
  });
}
